module.exports = __webpack_public_path__ + "static/media/the-champions.b9872584.gif";